import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import { SnackbarProvider } from "notistack";
import { Theme } from "@radix-ui/themes";
import { router } from "./router";
import { MantineProvider } from "@mantine/core";

import "@mantine/core/styles.layer.css";
import "mantine-datatable/styles.layer.css";
import "@radix-ui/themes/styles.css";
import "./styles/globals.css";

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Theme>
      <QueryClientProvider client={queryClient}>
        <MantineProvider defaultColorScheme="auto">
          <SnackbarProvider maxSnack={3}>
            <RouterProvider router={router} />
          </SnackbarProvider>
        </MantineProvider>
      </QueryClientProvider>
    </Theme>
  </React.StrictMode>
);
